import { getAppDispatch } from "utils/dispatch.util";
import http from "./http.service";
import Promisable from "./promisable.service";
import ToasterService from "utils/toaster.util";
import axios from "axios";
import { loaderActions } from "redux/slices/loader";
import imageCompression from "browser-image-compression";

const options = {
  maxSizeMB: 2, // Maximum size in MB
  maxWidthOrHeight: 1920, // Max width or height in pixels
  useWebWorker: true, // Use a web worker for faster compression
};
const ImageService = {
  getImageFileFromBlob: async ({ blob, name, type }: any) => {
    const response = await fetch(blob);
    const data = await response.blob();
    return new File([data], name, {
      type: response.headers.get("content-type") || type,
    });
  },

  getSignedUrl: async (data: {
    fileName: string;
    folderName: string;
    contentType: string;
  }): Promise<{ url: string; public_url: string; fileName: string } | null> => {
    http.setJWT();
    const [success, error]: any = await Promisable.asPromise(
      http.post(`/file/presigned-url`, data)
    );

    if (success && success?.data?.data) {
      return success?.data?.data;
    } else {
      ToasterService.showError(`${error?.errorMessage}`);
      return null;
    }
  },

  getImages: async (
    folderName: string
  ): Promise<
    { Key: string; public_LastModified: string; Size: string } | any
  > => {
    http.setJWT();
    const [success, error]: any = await Promisable.asPromise(
      http.get(`/file/get-files?folderName=${folderName}`)
    );

    if (success && success?.data?.data) {
      return success?.data?.data?.files;
    } else {
      ToasterService.showError(`${error?.errorMessage}`);
      return [];
    }
  },
  uploadToSignedUrl: async (url: any, file: any, progressFunc: any) => {
    const dispatch = getAppDispatch();
    const s3Axios = axios.create();
    dispatch?.(loaderActions.setImgLoading(true));
    // const bolfile = await ImageService.getImageFileFromBlob(file);

    s3Axios.defaults.baseURL = "";
    delete s3Axios.defaults.headers.common["Authorization"];

    try {
      // const compressedFile = await ImageService.compressImage(file);
      // console.log("compressedFile", compressedFile);
      await s3Axios.put(url, file, {
        headers: {
          "Content-Type": file.type,
        },
        onUploadProgress: (progressEvent: any) => {
          if (progressEvent.lengthComputable) {
            const percentComplete =
              (progressEvent.loaded / progressEvent.total) * 100;
            progressFunc(percentComplete);
            dispatch?.(loaderActions.setProgress(percentComplete));
            if (percentComplete == 100) {
              dispatch?.(loaderActions.setImgLoading(false));
              dispatch?.(loaderActions.setProgress(0));
            }
            console.log("percentComplete", percentComplete);
          }
        },
      });
    } catch (error) {}
  },
  compressImage: async (file: any) => {
    return await imageCompression(file, options);
  },
};

export default ImageService;
